import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-cancel-schedule-future-payment',
    templateUrl: './cancel-schedule-future-payment.component.html',
    styleUrls: ['./cancel-schedule-future-payment.component.scss'],
    imports: [RouterOutlet]
})
export class CancelScheduleFuturePaymentComponent {
    constructor() { }
}
